const waiting = {
    alert() {
        alert('內容還未上線，敬請期待');
    }
}

export default waiting